<template>
  <div class="guest-report px-3 pt-5">
    <!-- HEADER -->
    <b-row class="text-center mb-5">
      <b-col cols="12">
        <h1>PARTE DE VIAJERO</h1>
        <h2>(Real Decreto 933/2021 y Orden INT/1922/2003)</h2>
      </b-col>
    </b-row>

    <!-- DATOS ESTABLECIMIENTO -->
    <b-row v-if="accommodation" class="mb-3">
      <b-col cols="12" class="mb-1">
        <h2>DATOS DEL ESTABLECIMIENTO</h2>
      </b-col>
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <span>Nombre:</span>
          <span>{{ accommodation.name }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Código de establecimiento:</span>
          <span>{{ accommodation.hospedajesAccommodationCode }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Nº registro turístico:</span>
          <span>{{ accommodation.touristLicenceNumber }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Dirección:</span>
          <span>{{ accommodationFullAddress }}</span>
        </div>
      </b-col>
    </b-row>

    <!-- DATOS ESTANCIA -->
    <b-row v-if="booking" class="mb-3">
      <b-col cols="12" class=" mb-1">
        <h2>DATOS DEL CONTRATO</h2>
      </b-col>
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <span>Nº de reserva:</span>
          <span>{{ booking.localizator }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Fecha de reserva:</span>
          <span>{{ formatDateStringToDate(booking.date) }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Fecha de entrada:</span>
          <span>{{ formatDateStringToDate(booking.checkin) }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Fecha de salida:</span>
          <span>{{ formatDateStringToDate(booking.checkout) }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Nº de viajeros:</span>
          <span>{{ booking.guestsNumber }}</span>
        </div>
      </b-col>
    </b-row>

    <!-- DATOS VIAJERO -->
    <b-row class="mb-3">
      <b-col cols="12" class="mb-1">
        <h2>DATOS DEL VIAJERO</h2>
      </b-col>
      <b-col cols="12">
        <div class="d-flex justify-content-between">
          <span>Nombre:</span>
          <span>{{ guest.firstName }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>{{ guest.secondLastName ? 'Primer apellido:' : 'Apellido:' }}</span>
          <span>{{ guest.firstLastName }}</span>
        </div>
        <div v-if="guest.secondLastName" class="d-flex justify-content-between">
          <span>Segundo apellido:</span>
          <span>{{ guest.secondLastName }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Fecha de nacimiento:</span>
          <span>{{ formatDateStringToDate(guest.birthDate) }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Tipo de documento:</span>
          <span>{{ idTypeName(guest.idType) }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Nº de documento:</span>
          <span>{{ guest.idNumber }}</span>
        </div>
        <div v-if="guest.idSupportNumber" class="d-flex justify-content-between">
          <span>Nº de soporte:</span>
          <span>{{ guest.idSupportNumber }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span>Dirección:</span>
          <span>{{ guest.fullAddress }}</span>
        </div>
        <div v-if="guest.phone" class="d-flex justify-content-between">
          <span>Teléfono:</span>
          <span>{{ guest.phone }}</span>
        </div>
        <div v-else-if="guest.email" class="d-flex justify-content-between">
          <span>Email:</span>
          <span>{{ guest.email }}</span>
        </div>
      </b-col>
    </b-row>

    <!-- FOOTER -->
    <b-row class="text-center">
      <b-col cols="12">
        En {{ accommodationCity }}, a
        {{ formatDateStringToDate(confirmationDate) }}
      </b-col>
      <b-col cols="12"> Firma del viajero </b-col>
      <b-col cols="12 mb-3">
        <b-img v-if="guest.signature" class="guest-signature" :src="guest.signature" alt="" fluid center />
      </b-col>
      <b-col cols="12" class="lopd text-left">
        Los datos recogidos serán comunicados al Ministerio del Interior conforme al RD 933/2021 y se conservarán por el
        establecimiento durante 3 años. Datos protegidos según el Reglamento (UE) 2016/679 y la Ley Orgánica 3/2018.
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BImg } from "bootstrap-vue";
import { formatDateStringToDate } from "@/utils/formatters";
import { getIdTypeName } from "@/utils/methods";

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },
  props: {
    accommodation: {
      type: Object,
      default: null,
    },
    booking: {
      type: Object,
      default: null,
    },
    guest: {
      type: Object,
      default: null,
    },
  },
  computed: {
    accommodationFullAddress() {
      if (!this.accommodation?.location) return null;
      return this.accommodation.location.fullAddress;
    },
    accommodationCity() {
      if (!this.accommodation?.location) return null;
      return this.accommodation.location.city;
    },
    confirmationDate() {
      return this.guest?.confirmedDate || this.booking?.checkin;
    },
  },
  methods: {
    formatDateStringToDate(date) {
      return formatDateStringToDate(date);
    },
    idTypeName(code) {
      return getIdTypeName(code, "es");
    },
  },
};
</script>

<style lang="scss">
.guest-report {
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 14px;
  }
  h3 {
    font-size: 14px;
  }
  .guest-signature {
    max-width: 250px;
  }
  .lopd {
    font-size: 10px;
  }
}
</style>
